import React, { useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

export function CashlessCheckForm() {
  const [form, setForm] = useState({ insurer: "", tpa: "", hospital_name: "", pincode: "" });
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.hospital_name.trim()) { toast.error("Please enter the hospital name."); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/cashless-check", form);
      setResult(data);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  if (result) {
    const ok = result.covered;
    return (
      <div data-testid="cashless-result"
        className={`w-full max-w-sm rounded-xl border p-5 text-sm ${ok ? "border-emerald-200 bg-emerald-50 text-emerald-800" : "border-amber-200 bg-amber-50 text-amber-800"}`}>
        <p className="font-heading font-semibold mb-1">{ok ? "✅ Cashless covered" : "⚠️ Needs confirmation"}</p>
        <p>{result.message}</p>
        <button data-testid="cashless-again" onClick={() => setResult(null)}
          className="mt-3 text-xs font-medium underline">Check another hospital</button>
      </div>
    );
  }

  return (
    <form onSubmit={submit} data-testid="cashless-check-form"
      className="w-full max-w-sm rounded-xl border border-zinc-200 bg-white p-5 shadow-sm space-y-3">
      <p className="font-heading font-semibold text-emerald-950">Check cashless hospital</p>
      <p className="text-[11px] text-zinc-500 -mt-1">Enter the hospital details to check if cashless treatment is available.</p>
      <div className="space-y-1.5"><Label className="text-xs">Hospital name</Label>
        <Input data-testid="cashless-hospital" value={form.hospital_name} onChange={(e) => set("hospital_name", e.target.value)} placeholder="e.g. Apollo Hospital" /></div>
      <div className="grid grid-cols-2 gap-3">
        <div className="space-y-1.5"><Label className="text-xs">Pincode</Label>
          <Input data-testid="cashless-pincode" value={form.pincode} onChange={(e) => set("pincode", e.target.value.replace(/\D/g, ""))} maxLength={6} placeholder="560076" /></div>
        <div className="space-y-1.5"><Label className="text-xs">Insurer</Label>
          <Input data-testid="cashless-insurer" value={form.insurer} onChange={(e) => set("insurer", e.target.value)} placeholder="e.g. Star Health" /></div>
      </div>
      <div className="space-y-1.5"><Label className="text-xs">TPA name <span className="text-zinc-400">(optional)</span></Label>
        <Input data-testid="cashless-tpa" value={form.tpa} onChange={(e) => set("tpa", e.target.value)} placeholder="e.g. Medi Assist" /></div>
      <Button type="submit" disabled={loading} data-testid="cashless-submit"
        className="w-full rounded-full bg-emerald-900 hover:bg-emerald-800 text-white transition-colors">
        {loading ? "Checking…" : "Check cashless"}
      </Button>
    </form>
  );
}
